import React from "react";
import { ServicesGrid } from "../components/sections/ServicesGrid";
import { Seo } from "../components/Seo";
import { useI18n } from "../i18n/I18nContext";
import { PoseEagle } from "../components/PoseEagle";
import { Band } from "../components/Band";

export default function ServicesPage() {
  const { t } = useI18n();
  return (
    <main className="pt-40 lg:pt-36" data-testid="services-page">
      <Seo k="services" />
      <Band tone="dark" className="pb-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pb-4">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 max-w-5xl">
            <div className="max-w-3xl">
              <div className="eyebrow mb-3">{t.services.eyebrow}</div>
              <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter [overflow-wrap:anywhere] [hyphens:auto]">{t.services.title}</h1>
            </div>
            <PoseEagle
              src="/eagle-poses/eagle-services-scanning.png"
              size={200}
              mobileSize={105}
              entrance="scan"
              testid="services-eagle"
              className="shrink-0 self-end lg:-mb-10 lg:mr-2"
            />
          </div>
        </div>
      </Band>
      <Band tone="light">
        <ServicesGrid withHeader={false} />
      </Band>
    </main>
  );
}
